import { resolveOverdueChartConfigFromSnapshot, PERSISTED_CHART_KIND } from '../../board/lib/statisticsPersistedCharts';
import { buildOverdueChartConfigKey, collectOverdueOrdersForTable } from './overdueStatChartData';

export const buildOverdueChartBundle = ({ snapshot, overdueData = {}, isOverdueLoading = false }) => {
	const overdueConfig = resolveOverdueChartConfigFromSnapshot(snapshot);

	return {
		chartKind: PERSISTED_CHART_KIND.OVERDUE,
		overdueConfig,
		overdueData,
		orders: collectOverdueOrdersForTable(overdueData, overdueConfig.rangeMode),
		chartLoading: isOverdueLoading,
		animationKey: buildOverdueChartConfigKey(overdueConfig),
	};
};
